import { z } from 'zod';

export const MySoftwaresSearchSchema = z.object({
  page: z.number().default(1),
  pageSize: z.number().default(100),
});
